// Controller permettant d'appeler un formulaire Hubspot dans lequel on veut lui faire passer
// des paramètres spécifiques. Ces paramètres doivent être passés dans l'url de la page qui les appels
// C'est pourquoi on va ajouter ces paramètres à notre URL puis charger le script de hubspot
// qui va les récupérer puis on enlève les paramètres de l'url
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    portalId: String,
    propertyRef: String,
    fieldInternalName: { type: String, default: "property_reference" }
  }

  connect() {

    if (!this.hasPortalIdValue) return

    this.originalUrl = window.location.toString()
    // On ajouter la référence du bien dans l'url de notre page
    this.updateUrlWithPropertyRef()
    // On charge le script hubspot qui va prendre en compte la référence du bien dans l'url
    this.loadHubspotScript()
  }

  disconnect() {
    this.restoreOriginalUrl()
  }

  updateUrlWithPropertyRef() {
    if (!this.hasPropertyRefValue || !this.propertyRefValue) return

    const url = new URL(window.location.href)
    url.searchParams.set(this.fieldInternalNameValue, this.propertyRefValue)
    history.replaceState(null, "", url.toString())
  }

  loadHubspotScript() {
    const scriptId = `hubspot-forms-script-${this.portalIdValue}`

    let script = document.getElementById(scriptId)

    if (!script) {
      script = document.createElement("script")
      script.id = scriptId
      script.src = `https://js-eu1.hsforms.net/forms/embed/developer/${this.portalIdValue}.js`
      script.defer = true
      script.onload = this.handleScriptLoad.bind(this)
      document.head.appendChild(script)
      return
    }

    this.handleScriptLoad()
  }

  handleScriptLoad() {
    setTimeout(() => {
      this.restoreOriginalUrl()
    }, 5000)
  }

  restoreOriginalUrl() {
    if (!this.originalUrl) return
    history.replaceState(null, "", this.originalUrl)
  }
}
